import { Box, Popover, Stack } from '@mui/material';
import React from 'react';
import ChatBody from './ChatBody';
import ChatHeader from './ChatHeader';
import ChatInput from './ChatInput';

export default function ChatWindow({ anchorEl, onClose }) {
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Stack height={{ xs: '100vh', md: 600 }} width={{ xs: 1, md: 400 }}>
        <ChatHeader onClose={onClose} />
        <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
          <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
            <ChatBody />
            <ChatInput disabled />
          </Box>
        </Box>
      </Stack>
    </Popover>
  );
}
